import { authWaitMessage, retryAfterSeconds } from "../services/authThrottle";
import Unauthorized from "./Unauthorized";
import { setMessage } from "./slices/message";
import { contentErrorMessage } from "./slices/contentError";

const HandleError = (thunkAPI, error, type) => {
  const response = error && error.response;
  const status = response && response.status ? response.status : null;
  let messages = (response && response.data) || (error && error.message) || (error && error.toString && error.toString()) || "Request failed.";

  // Campaign forms consume Laravel-style fields; retain Flask's envelope too.
  if (status === 422 && messages && typeof messages === "object" && messages.error) {
    messages = {
      ...messages,
      message: messages.message || messages.error.message || "The given data was invalid.",
      errors: messages.errors || messages.error.fields || messages.fields || {},
    };
  }

  if (status === 422) {
    if (type === "login" && messages && messages.message) {
      thunkAPI.dispatch(setMessage(messages.message));
    }
  } else if (status === 401) {
    Unauthorized(thunkAPI, error?.config?.headers || response?.config?.headers);
  }

  const header = response?.headers?.["retry-after"] ?? response?.headers?.get?.("Retry-After");
  const retry_after = retryAfterSeconds({ message: messages }) ?? retryAfterSeconds({ retry_after: header });

  return thunkAPI.rejectWithValue({
    status,
    message: messages,
    ...(status === 429 && retry_after !== null ? { retry_after } : {}),
    userMessage: status === 429 ? authWaitMessage({ retry_after }) : contentErrorMessage({ payload: messages }, "Request failed."),
  });
};

export default HandleError;
